<template>
  <div class="">
    <section class="avater-section" :class="locale == 'ar' ? 'rtl' : 'ltr'">
      <div class="container">
        <div class="row w-100 text-center">
          <div class="col-md-12 text-center">
            <br /><br /><br />
            <div class="box-avater" style="margin-top: 30px">
              <img
                alt="success"
                class="img-error"
                src="/assets/img/checked.svg"
                style="width: 150px"
                loading="lazy"
              />
              <h4 class="sucess-text"><br />تمت عملية الدفع بنجاح</h4>

              <div class="col-md-12">
                <div class="table-responsive">
                  <table
                    class="table table-striped"
                    style="border: 1px solid #ddd"
                  >
                    <tr style="background: #eee">
                      <th>جهه التبرع</th>
                      <th>{{ row.data[0].proNameOrType }}</th>
                    </tr>
                    <tr>
                      <th>رقم الطلب</th>
                      <th>حالة العملية</th>
                    </tr>
                    <tr style="background: #eee">
                      <td>{{ row.invoice_id }}</td>
                      <td>{{ row.donation_status }}</td>
                    </tr>

                    <tr>
                      <td>المبلغ</td>
                      <td>تاريخ الإرسال</td>
                    </tr>
                    <tr style="background: #eee">
                      <td style="direction: ltr">
                        {{ row.amount }} {{ row.currency }}
                      </td>
                      <td>{{ row.date }}</td>
                    </tr>

                    <tr>
                      <td>رقم المرجع</td>
                      <td>طريقة الدفع</td>
                    </tr>
                    <tr style="background: #eee">
                      <td>{{ row.invoiceKey }}</td>
                      <td>
                        <span>{{
                          getPaymentMethodName(row.payment_method)
                        }}</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <br /><br />
              <div class="about-btn">
                <br />
                <div class="about-btn">
                  <router-link
                    :to="{ name: 'home' }"
                    class="default-btn theme_btn theme_btn_bg"
                  >
                    <i class="flaticon-right"></i>
                    الرجوع الي الصفحة الرئيسية
                    <span></span>
                  </router-link>
                </div>
                <br /><br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getPaymentMethods } from "@/data/paymentMethods";
import { trackDonate } from "@/helpers/pixel";

export default {
  name: "successNomination",
  components: {},
  data() {
    return {
      //
      auth: {
        access_token: "",
      },
      locale: "ar",
      pgLoading: true,
      hash: "",
      row: "",
      paymentMethods: [],
    };
  },
  mounted() {
  },
  created() {
    //
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    if (this.$route.query.hash) {
      this.hash = this.$route.query.hash;
    }

    this.fetchData();
    this.fetchPaymentMethods();
  },
  methods: {
    getPaymentMethodName(id) {
      const method = this.paymentMethods.find((m) => m.PaymentMethodId == id);
      return method
        ? this.locale == "ar"
          ? method.PaymentMethodAr
          : method.PaymentMethodEn
        : "";
    },
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/paymentNomiation/success",
        method: "GET",
        data: {},
        params: {
          hash: this.hash,
        },
      };
      this.$axios(options)
        .then((res) => {
          const donation = res.data.data || {};
          // trackDonate fires browser pixel + CAPI for Donate event only
          trackDonate(
            {
              value: donation.amount,
              currency: donation.currency,
              content_name:
                donation.data && donation.data[0]
                  ? donation.data[0].proNameOrType
                  : "",
              content_type: "project_nomination",
            },
            "nomination_" + (donation.invoice_id || this.hash),
            null,
            {
              mobile: donation.mobile,
              email: donation.email_address,
              name: donation.name,
            }
          );

          this.row = res.data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },

    async fetchPaymentMethods() {
      this.paymentMethods = await getPaymentMethods();
    },
  },
};
</script>

<style scoped=""></style>
